import Vue from "vue";

var elementExperssion;
var hasPermissions;
var currentUserPermissions;
var hasPermissionsList = [];
var permissionsListPrimary = [];
var permissionsListSecondary = [];
var permissionsListTemp = [];
// In page of sidebarItems , anything before * has no effect on the display
export const hasPermission = {
  bind(el, binding, vnode) {
    currentUserPermissions = localStorage.getItem("permissions");
    if (binding.value) {
      permissionsListPrimary = binding.value.split("*");
      if (permissionsListPrimary.length > 1) {
        permissionsListTemp[0] =
          permissionsListPrimary[permissionsListPrimary.length - 1];
        permissionsListSecondary = permissionsListTemp[0].split("|");
      } else {
        permissionsListSecondary = permissionsListPrimary[0].split("|");
      }
      for (let index = 0; index < permissionsListSecondary.length; index++) {
        elementExperssion = permissionsListSecondary[index];
        hasPermissionsList[index] = checkPermission(currentUserPermissions);
      }
      hasPermissions = hasPermissionsList.includes(true);
      if (!hasPermissions) {
        RemoveElement(vnode, el);
      }
      hasPermissionsList=[]
    }
  },

  update: function() {
    // do something based on the updated value
    // this will also be called for the initial value
  },
  unbind: function() {
    // do clean up work
    // e.g. remove event listeners added in bind()
  }
};

Vue.directive("has-permission", hasPermission);

function checkPermission(permissions) {
  var result = false;
  if (permissions === null) return false;
  permissions.split(",").filter(permission => {
    if (permission.toLowerCase() === elementExperssion.toLowerCase()) {
      result = true;
    }
  });
  return result;
}

function RemoveElement(vnode, el) {
  const comment = document.createComment(" ");
  Object.defineProperty(comment, "setAttribute", {
    value: () => undefined
  });
  vnode.elm = comment;
  vnode.text = " ";
  vnode.isComment = true;
  vnode.context = undefined;
  vnode.tag = undefined;
  vnode.data.directives = undefined;
  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment;
  }
  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
}
